// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getDepreciationScheduleReportEstimate } from '@/report/api/get-depreciation-schedule-report-estimate';
import { type DepreciationScheduleReportFilters } from '@/report/hooks/use-depreciation-schedule-report';
import { ONE_MINUTE_MS } from '@/utilities/time-constants';
import { useQuery } from '@tanstack/react-query';
import { DateTime } from 'luxon';

interface UseDepreciationScheduleReportEstimateOptions {
  filters?: DepreciationScheduleReportFilters;
}

export function useDepreciationScheduleReportEstimate(
  options: UseDepreciationScheduleReportEstimateOptions
) {
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['depreciation-schedule-report-estimate', options.filters],
    queryFn: () => {
      if (!options.filters) {
        throw new Error('Depreciation schedule filters are required');
      }

      return getDepreciationScheduleReportEstimate({
        startDate: DateTime.fromISO(options.filters.startDate),
        endDate: DateTime.fromISO(options.filters.endDate),
        itemKeys: options.filters.itemKeys,
        locationKeys: options.filters.locationKeys,
        currency: options.filters.currency,
      });
    },
    enabled: options.filters !== undefined,
    staleTime: ONE_MINUTE_MS,
  });
}
